import { toast } from "sonner";
import request from "../../../../helpers/request";

export const getDashboardGeralPublico = async (apiKey: string) => {
  const url = `${process.env.REACT_APP_API}/hub/GetDashboardGeral`;

  const result = await request({
    url,
    apiKey,
  });
  return result.data;
};
